export function getItems(details) {
  let cid = details.company_id
  let items = [
    {to: {name: 'ExchangeDashboard'}, label: 'Dashboard', icon: 'icon-Dashboard'},
    {to: {name: 'ExchangeSettings', params: {cid: cid}}, label: 'Settings', icon: 'icon-Dashboard'},
    {to: {name: 'ExchangeReports', params: {cid: cid}}, label: 'Reports', icon: 'icon-Reports'},
    {to: {name: 'ExchangeAdReview', params: {cid: cid}}, label: 'Ad Review', icon: 'icon-Reports'},
    {to: {name: 'ExchangeExplorer'}, label: 'Explorer', icon: 'icon-Reports'}
  ]
  return items
}



// WEBPACK FOOTER //
// ./src/exchange/menuitems.js